import LightBoxHeader from './LightBoxHeader'

export default LightBoxHeader
